import { render, staticRenderFns } from "./statregion.vue?vue&type=template&id=072f4852&"
import script from "./statregion.vue?vue&type=script&lang=js&"
export * from "./statregion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports